"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceReferences = class UcInvoiceReferences extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    get items() {
        if (this.loaded) {
            return this.invoice.references.data;
        }
        return null;
    }
    async act_4044930568678877_emit_9376_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async act_4044930568678877_crud_9374_getActionArgs($event) {
        return {
            objectType: "invoice_reference",
            op: "delete",
            data: {
                invoice_id: this.invoice.id,
                etag: this.invoice.etag,
                reference_type: $event.scope.item.object,
                reference_id: $event.scope.item.id,
            },
        };
    }
    async act_4044930568678877_crud_9374_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm deleting the reference."),
            btnOk: this.$fn.gettext("Delete reference"),
            severity: "warning",
        };
    }
    async evh_4044930568678877_click(event, scope) {
        return await this.actions.evh_4044930568678877_click.executeFromDOM(this, event, scope);
    }
    async act_8358196963355853_emit_9380_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8358196963355853_close_9379_getWhen($event) {
        return !!$event.data.modalResult && !!$event.data.modalResult.ok;
    }
    async act_8358196963355853_showModal_9378_getActionArgs($event) {
        return {
            name: "InvoiceReferenceSearch",
            props: {
                invoiceId: this.invoice.id,
            },
        };
    }
    async evh_8358196963355853_clickPrevent(event, scope) {
        return await this.actions.evh_8358196963355853_clickPrevent.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_4044930568678877_emit_9376 = new core_1.actions.EmitAction({
            actionArgs: this.act_4044930568678877_emit_9376_getActionArgs,
            events: [],
        });
        const evh_4044930568678877_success_9375 = new core_1.actions.EventHandlerImpl({
            action: act_4044930568678877_emit_9376,
            event: "success",
            displayName: "emit",
        });
        const act_4044930568678877_crud_9374 = new core_1.actions.CRUDAction({
            actionArgs: this.act_4044930568678877_crud_9374_getActionArgs,
            confirm: this.act_4044930568678877_crud_9374_getConfirm,
            events: [evh_4044930568678877_success_9375],
        });
        const evh_4044930568678877_click_9373 = new core_1.actions.EventHandlerImpl({
            action: act_4044930568678877_crud_9374,
            event: "click",
            displayName: "crud",
        });
        const evh_4044930568678877_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4044930568678877_click_9373],
        });
        const act_8358196963355853_emit_9380 = new core_1.actions.EmitAction({
            actionArgs: this.act_8358196963355853_emit_9380_getActionArgs,
            events: [],
        });
        const evh_8358196963355853_close_9379 = new core_1.actions.EventHandlerImpl({
            action: act_8358196963355853_emit_9380,
            event: "close",
            when: this.evh_8358196963355853_close_9379_getWhen,
            displayName: "emit",
        });
        const act_8358196963355853_showModal_9378 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8358196963355853_showModal_9378_getActionArgs,
            events: [evh_8358196963355853_close_9379],
        });
        const evh_8358196963355853_clickPrevent_9377 = new core_1.actions.EventHandlerImpl({
            action: act_8358196963355853_showModal_9378,
            event: "click.prevent",
            displayName: "showModal",
        });
        const evh_8358196963355853_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8358196963355853_clickPrevent_9377],
        });
        return {
            act_4044930568678877_emit_9376,
            evh_4044930568678877_success_9375,
            act_4044930568678877_crud_9374,
            evh_4044930568678877_click_9373,
            evh_4044930568678877_click,
            act_8358196963355853_emit_9380,
            evh_8358196963355853_close_9379,
            act_8358196963355853_showModal_9378,
            evh_8358196963355853_clickPrevent_9377,
            evh_8358196963355853_clickPrevent,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceReferences.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceReferences.prototype, "onInvoice", null);
UcInvoiceReferences = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceReferences);
exports.default = UcInvoiceReferences;
vue_property_decorator_1.Vue.component("UcInvoiceReferences", UcInvoiceReferences);
